import { Component, EventEmitter, Input, OnInit, Output, inject } from "@angular/core";
import { CerrixTextInputBase } from "../components/cerrix-textinput/cerrix-textinput-base";
import { AiSuggestionsPopupComponent } from "../ai-suggestions-popup/ai-suggestions-popup.component";
import { MatDialog } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { AiSettingsService } from "@app/ai/services/ai-settings-data.service";
import { TranslocoService, provideTranslocoScope } from "@jsverse/transloco";
import { firstValueFrom } from "rxjs";

@Component({
    selector: "ai-description-generator",
    templateUrl: "./ai-description-generator.component.html",
    styleUrls: ["./ai-description-generator.component.scss"],
    standalone: false,
    providers: [provideTranslocoScope({ scope: "shared/ai-description-generator", alias: "aiDescriptionGenerator" })],
})
export class AiDescriptionGeneratorComponent extends CerrixTextInputBase implements OnInit {
    @Input() fetchDescriptionsDatamethod: () => Promise<string[]>;
    @Input() rows = 3;
    @Input() autoGrowEnabled = false;

    @Output() onDescriptionGenerated = new EventEmitter<string>();

    generateDescriptionButtonDisabled: boolean = false;
    generateDescriptionButtonIcon: string;

    aiAssistanceEnabled: boolean = false;

    private _aiSettingsService = inject(AiSettingsService);
    private _toastr = inject(ToastrService);
    private _dialog = inject(MatDialog);
    private _translocoService = inject(TranslocoService);

    public constructor() {
        super();
        this.control.valueAccessor = this;
        this.multiline = true;
    }

    async ngOnInit(): Promise<void> {
        super.init();

        const isEnabled = await firstValueFrom(this._aiSettingsService.isEnabled());

        this.aiAssistanceEnabled = isEnabled;

        if (this.aiAssistanceEnabled) {
            this.enableDescriptionGeneratorButton();
        }
    }

    async generateDescription(): Promise<void> {
        if (!this.value || this.value.length === 0) {
            this._toastr.warning(this._translocoService.translate("aiDescriptionGenerator.enterDescriptionFirst"));
            return;
        }

        try {
            this.disableDescriptionGeneratorButton();

            var suggestions = await this.fetchDescriptionsDatamethod();

            this._dialog.open(AiSuggestionsPopupComponent, {
                data: {
                    suggestions: suggestions,
                    onConfirm: ((suggestion: string) => {
                        this.onDescriptionGenerated.emit(suggestion);
                    }).bind(this),
                },
                panelClass: "ai-suggestions-popup",
                width: "700px",
            });
        } finally {
            this.enableDescriptionGeneratorButton();
        }
    }

    private enableDescriptionGeneratorButton(): void {
        this.generateDescriptionButtonDisabled = false;
        this.generateDescriptionButtonIcon = "fas fa-wand-magic-sparkles";
    }

    private disableDescriptionGeneratorButton(): void {
        this.generateDescriptionButtonDisabled = true;
        this.generateDescriptionButtonIcon = "fas fa-hourglass-start";
    }
}
